import { createClient } from '@supabase/supabase-js';

// Hardcoded fallback keys provided by user for immediate functionality
const PROVIDED_URL = "https://fesqlnxuiobceeelticm.supabase.co";
const PROVIDED_KEY = "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6ImZlc3Fsbnh1aW9iY2VlZWx0aWNtIiwicm9sZSI6ImFub24iLCJpYXQiOjE3NjM5NzY4NTYsImV4cCI6MjA3OTU1Mjg1Nn0.RJoflHdra3eoQS7aeUpHMZto5a-CgECvbLVV0M7t5VY";

// Helper to safely get environment variables
const getEnvVar = (key: string) => {
  try {
    if (typeof import.meta !== 'undefined' && (import.meta as any).env && (import.meta as any).env[key]) {
      return (import.meta as any).env[key];
    }
  } catch (e) {}
  try {
    if (typeof process !== 'undefined' && process.env && process.env[key]) {
      return process.env[key];
    }
  } catch (e) {}
  return '';
};

const supabaseUrl = getEnvVar('VITE_SUPABASE_URL') || PROVIDED_URL;
const supabaseAnonKey = getEnvVar('VITE_SUPABASE_ANON_KEY') || PROVIDED_KEY;

export const supabase = createClient(supabaseUrl, supabaseAnonKey);

export const logAiRequest = async (requestType: string, success: boolean = true, metadata: any = {}) => {
    try {
        const { data: { user } } = await supabase.auth.getUser();
        await supabase.from('ai_logs').insert({
            request_type: requestType,
            user_id: user?.id,
            success: success,
            metadata: metadata
        });
    } catch (e) {
        console.error("Failed to log AI request", e);
    }
};